import React from 'react';
import Select from 'react-select';

class AbstractCountrySelect extends React.Component {
  placeholder = undefined;
  name = undefined;

  constructor(props) {
    super(props);

    this.state = {
      value: props.value || null
    };
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;

    if (value !== undefined && value !== this.state.value) {
      this.setState({ value });
    }
  }

  onChange(value) {
    this.setState({ value }, () => this.props.onSelect(value));
  }

  getOptions() {
    return [];
  }

  render() {
    const selectOptions = this.getOptions();

    let className = 'country-select-list';
    className += (this.props.className) ? ` ${this.props.className}` : '';

    return (
      <Select
        value={this.state.value || undefined}
        options={selectOptions}
        onChange={value => this.onChange(value)}
        className={ className }
        name={ this.name }
        placeholder={ this.placeholder }
        clearable={false}
        matchPos="start"
      />
    );
  }
}

export default AbstractCountrySelect;



// WEBPACK FOOTER //
// ./src/components/Selects/AbstractCountry.js